"use client";

import { c as _c } from "react/compiler-runtime";
import { TreatmentCaseList } from "@/features/home/ui";
import { Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import { useQueryHospitalTreatmentCaseList } from "@/entities/treatment-case/hooks/queries";
import { TreatmentCaseFilterResponse } from "@/shared/types/type/treatment";
import { TreatmentCaseSubjectFilter } from "@/widgets/treatment-case/ui/organisms";
import { useMemo, useState } from "react";
import useTreatmentCaseUIStore from "@/widgets/treatment-case/model/ui/store";
import { NoDataTemplates } from "@/shared/ui/templates";
import { shallow } from "zustand/shallow";
import { useTranslations } from "next-intl";
import { BannerTreatmentCase } from "@/widgets/hospital/ui/molecules";
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id";
const INITIAL_VISIBLE_COUNT = 3;
const VISIBLE_COUNT_INCREMENT = 10;
interface TreatmentCaseTabContentProps {
  filterList: TreatmentCaseFilterResponse;
  hospitalTreatmentId: number;
  /**
   * 새 상세 페이지의 섹션 셸 안에 들어갈 때. 제목과 바깥 여백은 섹션이 갖고 있으므로
   * 여기서는 내용만 그린다. 기본값(false)은 기존 상세 페이지의 모습 그대로다.
   */
  embedded?: boolean;
}
const TreatmentCaseTabContent = t0 => {
  const $ = _c(33);
  const {
    filterList,
    hospitalTreatmentId,
    embedded: t1
  } = t0;
  const embedded = t1 === undefined ? false : t1;
  const t = useTranslations();
  const hospitalOriginId = useHospitalOriginId();
  const {
    selectedSort,
    selectedSubjectId
  } = useTreatmentCaseUIStore(_temp, shallow);
  const queryKey = `${hospitalOriginId}:${selectedSort}:${selectedSubjectId}`;
  let t2;
  if ($[0] !== queryKey) {
    t2 = {
      queryKey,
      count: INITIAL_VISIBLE_COUNT
    };
    $[0] = queryKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [visibility, setVisibility] = useState(t2);
  const visibleCount = visibility.queryKey === queryKey ? visibility.count : INITIAL_VISIBLE_COUNT;
  if (visibility.queryKey !== queryKey) {
    setVisibility({
      queryKey,
      count: INITIAL_VISIBLE_COUNT
    });
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useQueryHospitalTreatmentCaseList(hospitalOriginId, selectedSort, selectedSubjectId);
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== data?.pages || $[3] !== embedded || $[4] !== fetchNextPage || $[5] !== filterList || $[6] !== hasNextPage || $[7] !== hospitalTreatmentId || $[8] !== isFetchingNextPage || $[9] !== queryKey || $[10] !== t || $[11] !== visibility || $[12] !== visibleCount) {
    const treatmentCaseSummaryList = data?.pages.flatMap(_temp2) ?? [];
    const totalCount = data?.pages[0].result.total ?? 0;
    const isEmpty = treatmentCaseSummaryList.length === 0;
    let t7;
    if ($[17] !== filterList || $[18] !== hospitalTreatmentId) {
      t7 = filterList.find(category => category.treatmentCategoryId === hospitalTreatmentId)?.treatmentSubjects ?? [];
      $[17] = filterList;
      $[18] = hospitalTreatmentId;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    const subjectFilterList = t7;
    const handleClickMore = async () => {
      if (isFetchingNextPage) {
        return;
      }
      const nextVisibleCount = Math.min(visibleCount + VISIBLE_COUNT_INCREMENT, totalCount);
      if (treatmentCaseSummaryList.length < nextVisibleCount && hasNextPage) {
        const result = await fetchNextPage();
        if (result.isError) {
          return;
        }
      }
      setVisibility(current => current === visibility ? {
        queryKey,
        count: nextVisibleCount
      } : current);
    };
    if ($[20] !== embedded || $[21] !== t || $[22] !== totalCount) {
      t5 = !embedded && totalCount > 990 && <Typography size={18} className="pt-5 px-4 pb-2.5 text-gray-800 font-bold">{t("treatmentCase.title")} {totalCount.toLocaleString("ko-KR")}</Typography>;
      $[20] = embedded;
      $[21] = t;
      $[22] = totalCount;
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    if ($[24] !== subjectFilterList) {
      t6 = subjectFilterList.length > 0 && <TreatmentCaseSubjectFilter subjectFilterList={subjectFilterList} />;
      $[24] = subjectFilterList;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    t3 = "px-5 ";
    t4 = isEmpty ? <div className="flex flex-col gap-[117px] items-center justify-center"><NoDataTemplates pageName="treatmentCase" priority={true} className="mt-[93px]" /><BannerTreatmentCase /></div> : <><TreatmentCaseList treatmentCaseSummaryList={embedded ? treatmentCaseSummaryList.slice(0, visibleCount) : treatmentCaseSummaryList} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} autoLoad={!embedded} />{embedded && visibleCount < totalCount && <CustomButton className="mt-2 mb-4 py-2 w-full bg-gray-100 rounded-lg" onClick={handleClickMore} disabled={isFetchingNextPage} ariaBusy={isFetchingNextPage}><Typography size={14} lineHeight={20} className="text-gray-900 font-medium">{t("common.more")}</Typography></CustomButton>}</>;
    $[2] = data?.pages;
    $[3] = embedded;
    $[4] = fetchNextPage;
    $[5] = filterList;
    $[6] = hasNextPage;
    $[7] = hospitalTreatmentId;
    $[8] = isFetchingNextPage;
    $[9] = queryKey;
    $[10] = t;
    $[11] = visibility;
    $[12] = visibleCount;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
  }
  let t7;
  if ($[26] !== t3 || $[27] !== t4) {
    t7 = <div className={t3}>{t4}</div>;
    $[26] = t3;
    $[27] = t4;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t8 = <div>{t5}{t6}{t7}</div>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
};
export default TreatmentCaseTabContent;
function _temp(s) {
  return {
    selectedSort: s.selectedSort,
    selectedSubjectId: s.selectedSubjectId
  };
}
function _temp2(page) {
  return page.result.contents;
}